<template>
    <div class="videoplay">
       <div class="close" @click="useSocket().seeOP('player',null)"></div>
       <div class="player">
        <video controls width="100%" height="100%" autoplay>
            <source :src="props.videoUrl" type="video/mp4">
                您的浏览器不支持视频播放。
        </video>
       </div>
    </div>    
</template>
  
  <script setup>
  import { defineProps } from 'vue';
  import { useSocket } from "@/stores/index";
  // 定义接收的参数
  const props = defineProps({
    videoUrl: {
      type: String,
      required: true
    }
  });
  </script>
  
  <style lang="scss" scoped>
  .videoplay {
    position: fixed;
    left:0;
    top: 0;
    width: 100%;
    height: 100%;
    z-index:9998888;
    background: rgb(0, 0, 0);
    .close{
        position: absolute;
        right:20px;
        top: 10px;
        background: url('@/assets/images/closeb.png') no-repeat center; 
        width:30px;
        height:30px;
        background-size: 30px 30px;
    }
    .player{
        width: 100%;
        height: 80%;
        top: 10%;
        position: absolute;
        left: 0;
    }
  }
  </style>